import React, { useContext, useEffect, useState, useRef, useReducer } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { useFormik } from 'formik';
import { getRequest, postRequest ,deleteRequest} from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,EditRowIcon,DeleteIcon, EditIcon, PaperClipIcon, ActivateIcon, DeactivateIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from 'react-loader-spinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import AuthContext from '../../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import UtilContext from '../../../components/UtilContext';
import { createAsyncNavigateHandlers } from '../../../utils/asyncArrayNavigate';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { normalizeForMatch } from '../../../utils/textNormalize';
import { primeMultiSelectHeaderFilter } from '../../../utils/primeMultiSelectHeaderFilter';
export default function TrainingTemplateRecordAdd({training_template, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter} = useContext(UtilContext);
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const submitRef = useRef(null);
    const overlayRef = useRef(null);

    const [trainingDepartment,setTrainingDepartment] = useState('');
    const [trainings,setTrainings] = useState([]);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({'training.department.name':true,'training.name':true,'training.type':true,'training.interval':true,'training.training_company.name':true,
        'machines':true,'training.employee.name':true,'training.description':true,});
    const [maskVisible, setMaskVisible] = useState(false);
const [formTemplate,setFormTemplate] = useState(training_template);
    const [formType, setFormType] = useState(type);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [loadingTemplateData, setLoadingTemplateData] = useState(true);

    const validTemplateId = (id) => id != null && id !== '' && Number(id) > 0;

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training"))?false:true);
    const [visibleCard,setVisibleCard] = useState(false);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);

    const [selectedCard,setSelectedCard] = useState(null);

    const [showTemplateRecordAdd, setShowTemplateRecordAdd] = useState(false);

    function addNewTrainingCard(){
        setTrainingDepartment('');
        const owned = (formTemplate?.template_records ?? []).map((card) => card.training_id);
        setTrainings((trainingTypesList || []).filter((training_type) => !owned.includes(training_type.id)));
        setSelectedCard(null);
        setShowTemplateRecordAdd(true);
    }

    function editNewTrainingCard(){
        const row = ref.current.getSelectedData()[0];
        if (!row) return;
        formikUpdate.setValues(row);
        const rowDeptId = row.training?.department_id ?? row.training?.department?.id;
        filterTrainings(rowDeptId ?? '', row.training);
        setVisibleCard(true);
    }

    function hideEditCard(){
        formikUpdate.resetForm();
        setVisibleCard(false);
    }

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        if(ref.current.getSelectedData().length === 1){
            if(user.permissions?.includes("edit training"))setEditIcon(false);
            if(user.permissions?.includes("delete training"))setDeleteIcon(false);
            if(user.permissions?.includes("add training"))setCopyIcon(false);
            setSelectedCard(ref.current.getSelectedData()[0]);
        }
    }

    function filterTrainings(departmentId,training=null){
        setTrainingDepartment(departmentId);
        const owned = (formTemplate?.template_records ?? []).map((card) => card.training_id);
        const types = trainingTypesList || [];
        const isEmpty = departmentId == null || departmentId === '' || (Array.isArray(departmentId) && departmentId.length === 0);
        if (isEmpty) {
            setTrainings(types.filter((t) => !owned.includes(t.id) || (training && t.id === training.id)));
        } else {
            const deptId = Number(departmentId);
            setTrainings(types.filter((t) => (t.department_id != null ? Number(t.department_id) : t.department?.id) === deptId && (!owned.includes(t.id) || (training && t.id === training.id))));
        }
    }

    // Keď je otvorený dialóg Pridať/Upraviť a načíta sa trainingTypesList, znovu naplň dropdown Názov školenia
    useEffect(() => {
        if (!showTemplateRecordAdd && !visibleCard) return;
        const owned = (formTemplate?.template_records ?? []).map((card) => card.training_id);
        const training = selectedCard?.training ?? null;
        const deptRaw = trainingDepartment;
        const isEmpty = deptRaw == null || deptRaw === '' || (Array.isArray(deptRaw) && deptRaw.length === 0);
        const types = trainingTypesList || [];
        const next = isEmpty
            ? types.filter((t) => !owned.includes(t.id) || (training && t.id === training.id))
            : types.filter((t) => (t.department_id != null ? Number(t.department_id) : t.department?.id) === Number(deptRaw) && (!owned.includes(t.id) || (training && t.id === training.id)));
        setTrainings(next);
    }, [showTemplateRecordAdd, visibleCard, trainingTypesList, trainingDepartment, formTemplate?.template_records, selectedCard?.training]);

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues:{
            training_id:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            formData.append("training_template_id",formTemplate.id);
            postRequest('/api/training_template_records', formData,true)
            .then((response) => {
                if (validTemplateId(formTemplate.id)) {
                  getRequest("/api/training_templates/" + formTemplate.id).then((r) => {
                    const updated = r?.data ?? r;
                    if (updated) setFormTemplate(updated);
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    formik.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    setShowTemplateRecordAdd(false);
                  }).catch(() => {});
                } else {
                    formik.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    setShowTemplateRecordAdd(false);
                }
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const formikUpdate = useFormik({
        initialValues: selectedCard == null ? {
            training_id:''
        } : selectedCard,
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                formData.append(value, values[value] != null ? values[value] : "");
            }
            formData.append("training_template_id",formTemplate.id);
            postRequest(`/api/training_template_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                if (validTemplateId(formTemplate.id)) {
                  getRequest("/api/training_templates/" + formTemplate.id).then((r) => {
                    const updated = r?.data ?? r;
                    if (updated) setFormTemplate(updated);
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setVisibleCard(false);
                    formikUpdate.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                  }).catch(() => {});
                } else {
                    setVisibleCard(false);
                    formikUpdate.resetForm();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const fetchRecord = async (direction, currentId) => {
        setDialogText?.(t('Common.Loading'));
        setVisible?.(true);
        try {
            const url = `/api/training_templates/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}`;
            const r = await getRequest(url);
            return r?.data ?? null;
        } finally {
            setVisible?.(false);
        }
    };
    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createAsyncNavigateHandlers(fetchRecord, setFormTemplate, () => formTemplate?.id);

    useEffect(() => {
        setLoadingTemplateData(true);
        Promise.all([
            validTemplateId(training_template?.id) ? getRequest("/api/training_templates/" + training_template.id).then((r) => r?.data ?? r).catch(() => null) : Promise.resolve(null),
            getRequest("/api/training_types?minimal=1").then((r) => r?.data ?? []).catch(() => []),
        ]).then(([template, types]) => {
            setTrainingTypesList(Array.isArray(types) ? types : []);
            if (template) setFormTemplate(template);
        }).catch(() => {}).finally(() => setLoadingTemplateData(false));
    }, [training_template?.id]);

    useEffect(() => {
        if (loadingTemplateData) {
            const t = ref.current;
            if (t?.initialized) t.alert?.(t('Common.LoadingEllipsis'));
        } else {
            ref.current?.clearAlert?.();
        }
    }, [loadingTemplateData]);

    const reloadCurrentTemplate = () => {
      if (!validTemplateId(formTemplate?.id)) return;
      setLoadingTemplateData(true);
      getRequest("/api/training_templates/" + formTemplate.id).then((r) => {
        const updated = r?.data ?? r;
        if (updated) setFormTemplate(updated);
      }).catch(() => {}).finally(() => setLoadingTemplateData(false));
    };

      function onEditRow(template_record){
        formikUpdate.setValues(template_record);
        setSelectedCard(template_record);
        const rowDeptId = template_record.training?.department_id ?? template_record.training?.department?.id;
        filterTrainings(rowDeptId ?? '', template_record.training);
        setVisibleCard(true);
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const accepttraining = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/training_template_records/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                if (validTemplateId(formTemplate?.id)) {
                  getRequest("/api/training_templates/" + formTemplate.id).then((r) => {
                    const updated = r?.data ?? r;
                    if (updated) setFormTemplate(updated);
                  }).catch(() => {});
                }
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: accepttraining
        });
    };

    function machineHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.training?.machines?.length<0)return false;
        const names = rowData.training?.machines?.map(machine => machine?.name).join('/') ?? '';
        return normalizeForMatch(names).includes(normalizeForMatch(headerValue ?? ''));
    }

    function trainingDepartmentHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        if (selected.length === 0) return true;
        const name = String(rowData?.training?.department?.name ?? rowValue ?? '').trim();
        if (!name) return false;
        const norm = normalizeForMatch(name);
        return selected.some(s => normalizeForMatch(s) === norm);
    }

    function trainingNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(rowData.training?.name ?? rowValue ?? '').trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function trainingCompanyNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(rowData.training?.training_company?.name ?? rowValue ?? '').trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function trainingEmployeeNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue || String(headerValue).trim() === '') return true;
        const name = String(rowData.training?.employee?.name ?? rowValue ?? '').trim();
        return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function MachineFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData.training.machines?.map(machine => machine?.name).join('/');
    }
      
    const [columns,setColumns] = useState([
        { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, minWidth: 44, headerSort: false, resizable: false },
        { hozAlign:"center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
        { title: t('Common.TrainingDepartment'), field: 'training.department.name', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: (state.departments || []).map(d => ({ label: d.name, value: d.name })), placeholder: t('Common.TrainingDepartment') }, headerFilterFunc: trainingDepartmentHeaderFilter, minWidth: 280, widthGrow: 1 },
        { title: t('Common.TrainingName'), field: 'training.name', minWidth: 200, widthGrow: 1, headerFilter: "input", headerFilterFunc: trainingNameHeaderFilter },
        { title: t('TrainingTypeList.Column.Type'), field: 'training.type', headerFilter: "input", minWidth: 200 },
        { title: 'Interval', field: 'training.interval', headerFilter: "input", minWidth: 200 },
        { title: t('Common.TrainingCompanyShort'), field: 'training.training_company.name', headerFilter: "input", headerFilterFunc: trainingCompanyNameHeaderFilter, minWidth: 200 },
        { title: 'Stroj', field: 'machines', headerFilter: "input", minWidth: 200, formatter: reactFormatter(<MachineFormatter/>), headerFilterFunc: machineHeaderFilter },
        { title: t('Common.Column.Responsible'), field: 'training.employee.name', headerFilter: "input", headerFilterFunc: trainingEmployeeNameHeaderFilter, minWidth: 200 },
        { title: t('Common.Description'), field: 'training.description', headerFilter: "input", minWidth: 320 },
    ]);

    useEffect(() => {
        const options = (state.departments || []).map(d => ({ label: d.name, value: d.name }));
        setColumns(prev => {
            const next = prev.map(col => col.field === 'training.department.name' ? { ...col, headerFilterParams: { options, placeholder: t('Common.TrainingDepartment') } } : col);
            if (ref.current?.setColumns) setTimeout(() => ref.current.setColumns(next), 0);
            return next;
        });
    }, [state.departments]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
       console.log(columnVisible);
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            ref.current.hideColumn(`${val}`);
          }
          else{
            ref.current.showColumn(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const defaultColumnsVisible = {'training.department.name':true,'training.name':true,'training.type':true,'training.interval':true,'training.training_company.name':true,'machines':true,'training.employee.name':true,'training.description':true};
    const resetMask = () => resetTabulatorMask({ page: 'TrainingTemplateRecordAdd', defaultColumnsVisible, ref, columns, setColumnsVisible });
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("TrainingTemplateRecordAdd","set_filters",null,ref.current.getHeaderFilters(),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("TrainingTemplateRecordAdd","set_filters",null,[],null);ref.current.clearHeaderFilter();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("TrainingTemplateRecordAdd","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("TrainingTemplateRecordAdd","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
        ]
      }
    ];
      function changeMarkings(value){
        if(value){
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="specific_id" || columnVisible[val]!=="editor" || columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=true;
              ref.current.showColumn(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
        else{
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="specific_id" || columnVisible[val]!=="editor"|| columnVisible[val]!=="end_of_validity"){
              columnVisible[val]=false;
              ref.current.hideColumn(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
      }


    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingCard()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editNewTrainingCard()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => reloadCurrentTemplate()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('TrainingTemplateRecordAdd.Text.Sablona_skolenia'),"TrainingTemplateRecordAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("TrainingTemplateRecordAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        {loadingTemplateData && !formTemplate ? (
        <div className="flex flex-col items-center justify-center h-[calc(100vh-177px)] bg-gray-100 gap-4">
            <InfinitySpin width="120" color="#333" />
            <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
        </div>
        ) : formTemplate ? (
        <>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto " minSize={5} size={5}>
        <form onSubmit={formik.handleSubmit} className='w-full'>
        <div className="relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
          <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.SKOLENIA_K_SABLONE')}</h1>
                {formType==="edit" && formTemplate != null && <label className="block text-md font-semibold text-gray-800">Por.č.: {formTemplate?.id ?? '—'}</label>}
                <div>
                    <label
                        htmlFor="name"
                        className="block text-md font-semibold text-gray-800"
                    >{t('ServiceTaskPlanner.TemplateNameLabel')}</label>
                    <input 
                        name='name'
                        type="text" readOnly
                        value={formTemplate.name}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>     
                <button className='hidden' type='submit' ref={submitRef}></button> 
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                        <div>
                            <label
                                htmlFor="department_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('TrainingTemplateList.Text.Oddelenie_sablony')}</label>
                            <select
                            name='department_id' disabled
                            value={formTemplate.department_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                            {(state.departments || []).map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                            </select>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Description')}</label>
                        <textarea
                            name='description'
                            type="text" readOnly
                            value={formTemplate.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                    </div>
                </div>  
            </div>
            </div> 
            </div>
             </form>
             </SplitterPanel>
    <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
    <ReactTabulator
      data={formTemplate?.template_records ?? []} 
      onRef={(r) => (ref.current = r.current)}
      className='h-full w-full' //176px h-[calc(100vh_-_176px)]
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
            if (loadingTemplateData) ref.current?.alert?.(t('Common.LoadingEllipsis'));
            let mask = (state.user_mask_filters || []).filter(mask => mask.page=="TrainingTemplateRecordAdd");
            const safeParse = (v, fallback) => {
                if (v === null || v === undefined) return fallback;
                if (typeof v === "string") {
                try { return JSON.parse(v); } catch { return fallback; }
                }
                return v; // už je array/object
            };
            if (mask.length > 0) {
                const attributes  = safeParse(mask[0].attributes, []);
                const filters     = safeParse(mask[0].filters, []);
                const sorters     = safeParse(mask[0].sorters, []);
                const json_columns = safeParse(mask[0].columns, {});
                if (Array.isArray(attributes) && attributes.length > 1) {
                    ref.current.setColumnLayout(attributes);
                }
                if (Array.isArray(filters)) {
                    filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
                }
                if (Array.isArray(sorters) && sorters.length > 0) {
                    ref.current.setSort(sorters);
                }
                if (json_columns && typeof json_columns === "object") {
                    setColumnsVisible(json_columns);
                    for (let column in json_columns) {
                        if (json_columns[column] === false) ref.current.hideColumn(column);
                        else ref.current.showColumn(column);
                    }
                }
            }
          },
        columnMoved: () => { setUserMaskFilter("TrainingTemplateRecordAdd", "column_move", null, null, ref.current.getColumnLayout()); },
        columnResized: () => { setUserMaskFilter("TrainingTemplateRecordAdd", "column_resized", null, null, ref.current.getColumnLayout()); },
      }}
      options={{renderHorizontal:"virtual",rowHeight:30,movableColumns:true,resizableColumnFit:true,
      dataLoader: true,
      dataLoaderLoading: t('Common.LoadingData'),
      dataLoaderError: t('Common.LoadFailed'),
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('Print.Title.TrainingTemplateRecordAdd'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active",
      initialSort:[
        {column:"training.department.name", dir:"asc"},
      ]
      }}/>
    </SplitterPanel>
    </Splitter> 
    <Dialog header={t('MaintenanceTemplateRecordAdd.Text.Upravit_v_sablone')} visible={visibleCard} style={{ width: '40vw' }} onHide={() => hideEditCard()}>
        <form onSubmit={formikUpdate.handleSubmit}>
            <div>
                <label
                    htmlFor="trainingDepartment"
                    className="block text-md font-semibold text-gray-800"
                >{t('Common.TrainingDepartment')}</label>
                <select 
                required
                name='trainingDepartment'
                onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                {(state.departments || []).map((department) => (
                    <option key={department.id} value={department.id}>{department.name}</option>
                    ))}
                </select>
            </div>
            <div>
                <label
                    htmlFor="training_id"
                    className="block text-md font-semibold text-gray-800"
                >
                {t('Common.TrainingName')}
                </label>
                <select required
                name='training_id'
                onChange={formikUpdate.handleChange} value={formikUpdate.values.training_id}
                className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                {trainings.map((training) => (
                    <option key={training.id} value={training.id}>{training.name}</option>
                ))}
                </select>
            </div>          
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
    </Dialog>
        <Dialog header={t('MaintenanceTemplateRecordAdd.Text.Pridat_do_sablony')} visible={showTemplateRecordAdd} style={{ width: '40vw' }} onHide={() => setShowTemplateRecordAdd(false)}>
        <form onSubmit={formik.handleSubmit}>
            <div>
                <label
                    htmlFor="trainingDepartment"
                    className="block text-md font-semibold text-gray-800"
                >{t('Common.TrainingDepartment')}</label>
                <select 
                required
                name='trainingDepartment'
                onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                {(state.departments || []).map((department) => (
                    <option key={department.id} value={department.id}>{department.name}</option>
                    ))}
                </select>
            </div>
            <div>
                <label
                    htmlFor="training_id"
                    className="block text-md font-semibold text-gray-800"
                >
                {t('Common.TrainingName')}
                </label>
                <select required
                name='training_id'
                onChange={formik.handleChange} value={formik.values.training_id}
                className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                {trainings.map((training) => (
                    <option key={training.id} value={training.id}>{training.name}</option>
                ))}
                </select>
            </div>  
            <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>         
        </form>
        </Dialog>
        <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingTemplateRecordAdd","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
            </>
        ) : null}
            </div>
            </> 
            );
} 
